<template>
    <v-dialog max-width="450" persistent v-model="dialog">
        <v-card>
            <v-card-title class="headline">Update Application Details</v-card-title>
            <v-card-text>
                <ValidationObserver ref="observer" v-slot="{failedRules, failed ,passes}">
                    <form>
                        <ValidationProvider  vid="applicationNumber" name="applicationNumber"
                                             :rules="{ min:3, max:25, regex:/^[a-zA-Z0-9-]+$/ }" ref="observerEditApplicationNumber"
                                            v-slot="{errors, failedRules}">
                            <v-text-field
                                    :error-messages="$translatedErrorMessages(failedRules,'applicationNumber')"
                                    label="Application Number" disabled
                                    v-model="application.applicationNumber">
                            </v-text-field>
                        </ValidationProvider>

                        <ValidationProvider rules="required" v-slot="{errors, failedRules}">
                            <v-select
                                    :error-messages="$translatedErrorMessages(failedRules,'customerApplicationStatus')"
                                    :items="$parent.filters.applicationStatus"
                                    item-text="text"
                                    item-value="value"
                                    label="Application Status"
                                    v-model="application.applicationStatus"
                            >
                            </v-select>
                        </ValidationProvider>

                        <div v-if="application.applicationStatus === 'A'">
                            <ValidationProvider
                                    :rules="{numeric:true, required: true, min_value: validation.minAmount, max_value: validation.maxAmount }"
                                    v-slot="{errors, failedRules}">
                                <v-text-field
                                        :error-messages="$translatedErrorMessages(failedRules,'financingAmountApproved', [validation.minAmount, validation.maxAmount])"
                                        label="Financing Amount Approved"
                                        prefix="$"
                                        required
                                        v-model="application.financingAmountApproved">
                                </v-text-field>
                            </ValidationProvider>
                            <ValidationProvider
                                    :rules="{numeric:true, required: true, min_value: validation.minTenure, max_value: validation.maxTenure  }"
                                    v-slot="{errors, failedRules}">
                                <v-text-field
                                        :error-messages="$translatedErrorMessages(failedRules,'tenureApproved', [validation.minTenure, validation.maxTenure])"
                                        label="Tenure Approved"
                                        required
                                        suffix="Months"
                                        v-model="application.tenureApproved">
                                </v-text-field>
                            </ValidationProvider>
                        </div>

                        <ValidationProvider :rules="{required: false, min : 1, max : 3, regex:/^[a-zA-Z0-9\s-+#@]+$/ }"
                                            v-slot="{errors, failedRules}">
                            <v-text-field :error-messages="$translatedErrorMessages(failedRules,'internalRating')"
                                          label="Internal Credit Rating" v-model="application.internalRating"></v-text-field>
                        </ValidationProvider>
                    </form>
                    <div>
                        <div v-show="serverError">
                            <p style="color:red" >Something went wrong. Please try again later</p>
                        </div>
                    </div>
                    <v-card-actions align="right">
                        <v-spacer></v-spacer>
                        <v-skeleton-loader class="mr-3" :loading="loader" transition="scale-transition" type="button">
                            <v-btn @click="dialog=false" color="primary">Cancel</v-btn>
                        </v-skeleton-loader>
                        <v-skeleton-loader :loading="loader" transition="scale-transition" type="button">
                            <v-btn @click="passes(updateApplicationStatus)" color="primary" dark>
                                Save
                            </v-btn>
                        </v-skeleton-loader>
                    </v-card-actions>
                </ValidationObserver>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import {ValidationObserver, ValidationProvider} from 'vee-validate';
    import {dataServices} from "@/services";


    export default {
        components: {
            ValidationObserver, ValidationProvider
        },
        data() {
            return {
                dialog: false,
                application: {},
                loader: false,
                validation: {
                    minAmount: 100000000,
                    maxAmount: 10000000000,
                    minTenure: 6,
                    maxTenure: 240
                },
                internalRatingAvailableItems: [
                    {text: 'Yes', value: 'Y'},
                    {text: 'No', value: 'N'}
                ],
              pefindoScoreAvailableItems: [
                    {text: 'Yes', value: 'Y'}, {
                        text: 'No', value: 'N'}
                ],
              fintechDataCenterScoreAvailableItems: [
                    {text: 'Yes', value: 'Y'},
                    {text: 'No', value: 'N'}
                ],
                serverError: false
            }
        },
        methods: {
            init() {
                this.application = Object.assign({}, this.$parent.selectedApplication)
                this.dialog = true
                let productValidation = this.$parent.filters.scheme.filter(f => f.code === this.application.productApplied)[0].validation
                console.log(productValidation)
                if(productValidation)
                   this.validation=productValidation
            }, updateApplicationStatus() {
                this.loader = true
                dataServices.editApplicationStatus(this.application).then((response) => {
                    this.loader = false
                    if (response.successful) {
                        this.$parent.renderMessage('Successfully updated the application details')
                        this.dialog = false
                        this.loader = false
                    } else {
                        response.errorList.forEach(e => {
                            if(e.field==='applicationNumber' && e.rule==='duplicate'){
                                this.$refs.observerEditApplicationNumber.applyResult({
                                    errors: ['error'],
                                    failedRules: ['duplicate']
                                });
                            }
                        })
                    }
                }).catch((error) => {
                    this.loader = false
                    this.serverError = true
                    console.log('Error' + error)
                })
            }
        }
    }
</script>
